import Profile from './components/Profile';
import Icon from 'components/common/Icon';
import useBottomSheet from 'hooks/common/useBottomSheet';
import TeamLinkleProfile from './TeamLinkleProfile';
import useUserProfile from 'hooks/profile/useUserProfile';

type UserProfileType = 'user' | 'loveMatch';

function UserProfile() {
  const { getSheet, close, sheets } = useBottomSheet();

  const sheet = getSheet('UserProfile');
  const type: UserProfileType = sheet.data.type;
  const userId: string = sheet.data.uid;
  const {
    userInfo,
    followerCount,
    isFollowing,
    isTeamLinkle,
    isAdmin,
    coin,
    disableChat,
    disableCall,
    handleFollow,
    handleMessage,
    handleCall
  } = useUserProfile({ userId, type });

  const handleAction = (action: 'msg' | 'call') => {
    Object.values(sheets).forEach((sheet) => close(sheet.id));
    if (action === 'msg') handleMessage();
    else handleCall();
  };

  return userInfo && !isTeamLinkle ? (
    <Profile userInfo={userInfo}>
      <Profile.Image>
        <Profile.BlockUserButton />
      </Profile.Image>

      <div className="flex flex-col">
        <div className="mt-4 flex items-center gap-2">
          <Profile.Name />
          <Profile.Coin coin={coin} type={type} />
        </div>
        <div className="mb-4 mt-3 flex flex-col items-start gap-3">
          {isAdmin && <Profile.Uid />}
          <div className="flex items-center gap-2">
            <Profile.Country />
            <Profile.TimeInfo />
          </div>
        </div>

        <hr className="m-0 h-[1px] w-full border-base-border-default" />

        <div className="my-4 flex items-center justify-between rounded-full bg-base-bg-subtle px-2 py-1">
          <div className="flex items-center gap-1">
            <Icon name="profile/profile.svg" className="flex-shrink-0 items-center justify-center px-2 py-1" size={24} />
            <div className="flex flex-1 items-center justify-center gap-2 py-3">
              <Profile.Stats type="follower" count={followerCount} />
            </div>
          </div>

          <div className="flex items-center justify-center py-1">
            <div
              className={`flex items-center justify-center gap-1 rounded-full px-3 py-2 bg-btn-bg-normal`}
              onClick={handleFollow}
            >
              <Icon name={isFollowing ? 'inroom/check.svg' : 'profile/follow_add.svg'} className="flex-shrink-0 items-center justify-center px-2 py-1" size={24} />
              <div className="typography-headline-sm text-btn-txt-normal">{isFollowing ? brsc.following : brsc.followers}</div>
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 flex items-center justify-center gap-2">
          <div onClick={() => handleAction('msg')} className="flex flex-1 items-center justify-center py-1">
            <div
              className={`${disableChat ? 'pointer-events-none opacity-50' : 'cursor-pointer'} flex flex-1 items-center justify-center gap-1 rounded-full px-5 py-4 bg-btn-bg-normal`}
            >
              <Icon name="profile/message.svg" size={24} />
              <div className="typography-headline-lg text-btn-txt-secondary">{BResource.getCommon(BResource.getSelectedLocale() ?? 'default', 'message')}</div>
            </div>
          </div>
          <div
            onClick={() => handleAction('call')}
            className={`${disableCall ? 'pointer-events-none opacity-50' : 'cursor-pointer'} flex flex-1 items-center justify-center py-1`}
          >
            <div className={`flex flex-1 items-center justify-center gap-1 rounded-full bg-btn-bg-video-primary px-5 py-4`}>
              <Icon name="profile/video_call.svg" size={24} />
              <div className="typography-headline-lg text-btn-txt-secondary">{brsc.call_icon}</div>
            </div>
          </div>
        </div>
      </div>
    </Profile>
  ) : (
    <TeamLinkleProfile userInfo={userInfo} handleAction={handleAction} />
  );
}
export default UserProfile;
